import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

interface GpsPoint {
  latitude: number
  longitude: number
  speed: number
  heading: number
  timestamp: string
}

interface SensorPoint {
  value: number
  timestamp: string
}

interface SensorStats {
  min: number
  max: number
  avg: number
  count: number
}

interface TimeRange {
  device_id: string
  from: string
  to: string
}

export function useGpsTrack(params: TimeRange & { limit?: number }) {
  return useQuery({
    queryKey: ['analytics', 'gps-track', params],
    queryFn: () =>
      api
        .get<{ points: GpsPoint[] }>('/analytics/gps/track', { params })
        .then((r) => r.data.points ?? []),
    enabled: !!params.device_id,
  })
}

export function useSensorHistory(
  params: TimeRange & { sensor_key: string; limit?: number },
) {
  return useQuery({
    queryKey: ['analytics', 'sensor-history', params],
    queryFn: () =>
      api
        .get<{ points: SensorPoint[] }>('/analytics/sensors/history', { params })
        .then((r) => r.data.points ?? []),
    enabled: !!params.device_id && !!params.sensor_key,
  })
}

export function useSensorStats(params: TimeRange & { sensor_key: string }) {
  return useQuery({
    queryKey: ['analytics', 'sensor-stats', params],
    queryFn: () =>
      api
        .get<SensorStats>('/analytics/sensors/stats', { params })
        .then((r) => r.data),
    enabled: !!params.device_id && !!params.sensor_key,
  })
}

export function useSensorKeys(device_id: string) {
  return useQuery({
    queryKey: ['analytics', 'sensor-keys', device_id],
    queryFn: () =>
      api
        .get<{ keys: string[] }>('/analytics/sensors/keys', { params: { device_id } })
        .then((r) => r.data.keys ?? []),
    enabled: !!device_id,
  })
}
